(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ind-new-blog-hero"] && !Shopify.designMode) return;
  try {
    
  /* Share button: Web Share API with copy-link fallback */
  (function () {
    var btn = document.querySelector('.js-share');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-url');
      var title = btn.getAttribute('data-title');

      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }

      var label = btn.querySelector('.ind-new-blog-hero__share-label');
      var original = label ? label.textContent : '';

      function flash(msg) {
        if (!label) return;
        label.textContent = msg;
        setTimeout(function () { label.textContent = original; }, 1500);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          flash('Link copied');
        }).catch(function () {
          flash('Copy failed');
        });
      } else {
        flash(url);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
